module.exports = __webpack_public_path__ + "static/img/device-1.09729bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/device-1.png
// module id = YjmH
// module chunks = 0